import { Ref, ref } from 'vue-demi';
import { queryGoodsId, getGoodsInfo } from '../api/index';
import { COUPON_TYPE } from '@/api/displayCoupon/display-coupon';
import { isDisplayCoupon } from '@/business/display-coupon-record';


/**
 * CDK兑换前查询兑换奖品信息
 * @param cdkey
 * @returns
 */
export function useGoodsInfo(cdkey: Ref<string>) {
  const goodsInfo = ref({
    id: '',
    name: '',
    isDisplayCoupon: false,
  });

  async function initGoodsInfo(ticket: string, randstr: string) {
    const id = await queryGoodsId(cdkey.value, ticket, randstr);
    const info = await getGoodsInfo(id);
    goodsInfo.value = {
      id,
      name: info.coupon_name,
      isDisplayCoupon: isDisplayCoupon(info.coupon_type as COUPON_TYPE),
    };
  };

  return {
    goodsInfo,
    initGoodsInfo,
  };
}
